import { render, staticRenderFns } from "./SupplierProductSettings.vue?vue&type=template&id=0a70b070&"
import script from "./SupplierProductSettings.vue?vue&type=script&lang=js&"
export * from "./SupplierProductSettings.vue?vue&type=script&lang=js&"
import style0 from "./SupplierProductSettings.vue?vue&type=style&index=0&id=0a70b070&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports